const { REACT_APP_SHOW_INDIAN_FLAG = 'false' } = process.env;

const showIndianFlag = REACT_APP_SHOW_INDIAN_FLAG === 'true' ? true : false;

export const isShowIndianFlag = showIndianFlag;

// Diwali Diya. Enbale it during diwali
export const isShowDiwaliDiya = true;
